export const initialConfigsState = {
    cancelationDisabledOrgIds : ["100", "473", "451", "504"],
    loading:false
  }